import React from "react";
import AddEntity from "../../../Entities/Modules/EntityAddEntity";
import AreaEditor from "../../../Forms/Onboarding/AreaEditor";
import FacilityEditor from "../../../Forms/Onboarding/FacilityEditor";
import ValetAreaEditor from "../../../Forms/Onboarding/ValetAreaEditor";
import FacilityGroupEditor from "../../../Forms/Onboarding/FacilityGroupEditor";
import DeviceEditor from "../../../Forms/Onboarding/DeviceEditor";
import EntityQRCode from "../../../Entities/Modules/EntityQRCode";
import {useSelector} from "react-redux";
import _ from "lodash";

export const DrawerContent = ({
                                  contentType,
                                  entityId,
                                  selectionCallback,
                                  handleAddEntity,
                                  handleDeleteEntity,
                                  closeDrawer
                              }) => {

    const entity = useSelector((state) => state.orgTree.entities[entityId], (prev, next) => _.isEqual(prev, next));

    const getDrawerContent = (contentType) => {
        switch (contentType) {
            case "child-selector":
                return (
                    <AddEntity
                        entityID={entityId}
                        selectionCallback={selectionCallback}
                        isDeviceControl={true}
                    />
                );
            case "add-area":
                return (
                    <AreaEditor
                        entityID={null}
                        parentEntityID={entityId}
                        mode="create"
                        onCancel={() => closeDrawer()}
                        onSubmitComplete={handleAddEntity}
                        onDeleteComplete={handleDeleteEntity}
                    />
                );
            case "add-facility":
                return (
                    <FacilityEditor
                        entityID={null}
                        parentEntityID={entityId}
                        mode="create"
                        onCancel={() => closeDrawer()}
                        onSubmitComplete={handleAddEntity}
                        onDeleteComplete={handleDeleteEntity}
                    />
                );
            case "add-valetarea":
                return (
                    <ValetAreaEditor
                        entityID={null}
                        parentEntityID={entityId}
                        mode="create"
                        onCancel={() => closeDrawer()}
                        onSubmitComplete={handleAddEntity}
                    />
                );
            case "add-facilitygroup":
                return (
                    <FacilityGroupEditor
                        entityID={null}
                        parentEntityID={entityId}
                        mode="create"
                        onCancel={() => closeDrawer()}
                        onSubmitComplete={handleAddEntity}
                        onDeleteComplete={handleDeleteEntity}
                    />
                );
            case "add-device":
                return (
                    <DeviceEditor
                        entityID={null}
                        parentEntityID={entityId}
                        parentEntityData={entity}
                        mode="create"
                        onCancel={() => closeDrawer()}
                        onSaveComplete={handleAddEntity}
                        onDeleteComplete={handleDeleteEntity}
                    />
                );
            case "provision":
                return (
                    <EntityQRCode
                        entityID={entityId}
                        onClose={() => closeDrawer()}
                    ></EntityQRCode>
                );
            default:
                // Return null or a fallback UI
                return null;
        }
    };

    return getDrawerContent(contentType);
}